// extracted by mini-css-extract-plugin
export default {"mainContainerStyle":"styles_mainContainerStyle__QVvRY","mainInsideContainerStyle":"styles_mainInsideContainerStyle__8Wsue"};